import * as d3 from "d3";
import {
    axisTextDim1,
    colonAnnotation, contextMenu, createTooltip,
    fw_progressive_2way, generateDownloadData,
    numberFormat,
    XaxisAttribute
} from '../functions'

export default function (chart, divId, vizName,resData, filterParam, checkbox) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = chart.axisLabelFontSize + "px"
    //var tempVar = chart.tempVar

    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    function responsivefy(svg) {
        var container = d3.select(svg.node().parentNode),
            width = parseInt(svg.style('width')),
            height = parseInt(svg.style('height')),
            aspect = width / height

        svg.attr('viewBox', '0 0 ' + width + ' ' + height)
            .attr('perserveAspectRatio', 'xMinYMid')
            .call(resize)

        d3.select(window).on('resize.' + container.attr('id'), resize)

        function resize() {
            var targetWidth = parseInt(container.style('width'))
            svg.attr('width', targetWidth / 4)
            svg.attr('height', Math.round(targetWidth / 4 / aspect))
        }
    }

    // axios.post(url, filterParam).then(res => {
        let data = resData
        var categories = d3.nest()
            .key((d) => {
                return d.dim2_name
            })
            .entries(data);

//           add color
        var metric1ColorScale = d3.scaleOrdinal().range(fw_progressive_2way)

        var x1Scale = d3.scaleBand().rangeRound([0, chart.width]).padding(0.1)

        // Scales. Note the inverted domain fo y-scale: bigger is up!
        var y1Scale = d3.scaleLinear().range([chart.height, 0]);

        var x1AxisLabel = d3.axisBottom(x1Scale)
            .tickSizeInner(-chart.height)
            .tickSizeOuter(-chart.height)

        var y1AxisLabel = d3.axisLeft(y1Scale)
            .tickSizeInner(-chart.width)
            .tickSizeOuter(0)
            .tickFormat(numberFormat)
            .ticks(4)

        // d3.select(".d3-tipmspc" + divId.id).remove(); // clear tooltip based on class of tip element


        // y1tip.attr('class', 'd3-tipmspc' + divId.id)
        //     .offset([-10, 0])
        //     .html(function (d) {
        //         return d.dim1_name + colonAnnotation + numberFormat(d.metric1);
        //     })

        // Parse dates and numbers. We assume values are sorted by date.
        // Also compute the maximum price per symbol, needed for the y-domain.
        categories.forEach(function (c) {
            c.values.forEach(function (d) {
                d.metric1 = +d.metric1;
            })
        });

        var years = data.map(function (d) {
            return d.dim3_name
        })

        console.warn("years", years)
        if (checkbox == true) {
            x1Scale.domain(data.map(function (d) {
                return d.dim1_name;
            }));

            svg = d3.select(divId)
            svg.selectAll("*").remove();

            // Add an SVG element for each country, with the desired dimensions and margin.
            svg= d3.select(divId).selectAll("svg")
                .data(categories)
                .enter()
                .append("svg")
                .attr("width", chart.width + chart.margin.left + chart.margin.right)
                .attr("height", chart.height + chart.margin.top + chart.margin.bottom)
                .call(responsivefy)
                .append("g")
                .attr("transform", "translate(" + chart.margin.left + "," + chart.margin.top + ")")
                .attr("id", function (d) {
                    return d.key;
                })

            var tooltip = createTooltip(divId);

            categories.forEach(function (d) {
                //CSS.escape(id) - will escape special character in id/key
                svg = d3.select("#" + CSS.escape(d.key));

                y1Scale.domain([0, d3.max(d.values, function (d) {
                    return d.metric1
                })])

                svg.append("g")
                    .attr("class", "x axis")
                    .attr('class', 'axis-grid')
                    .attr("transform", "translate(0," + chart.height + ")")
                    .call(x1AxisLabel)
                    .selectAll('text')
                    .style('font-size', axisLabelFontSize)
                    .style('text-anchor', 'start')
                    .attr('dx', XaxisAttribute)
                    .attr('transform', 'rotate(-50)')
                    .text(axisTextDim1)

                svg.append("g")
                    .style("fill", "white")
                    .attr('class', 'y axis-grid')
                    .style('fill', 'none')
                    .call(y1AxisLabel)
                    .selectAll('text')
                    .style('font-size', axisLabelFontSize)

                //adding x-y-axis labels
                svg.append("text")
                    .attr("transform", "translate(" + (chart.width / 2) + " ," + (chart.height + chart.margin.top + 52) + ")")
                    .style("text-anchor", "middle")
                    .style('display', 'none')
                    .text(chart.x1AxisDisplayName)
                    .style('fill', fontColor);

                svg.append("text")
                    .attr("transform", "rotate(-90)")
                    .attr("y", 10)
                    .attr("dy", "-4em")
                    .style("text-anchor", "end")
                    .attr("font-size", fontSize)
                    .style('display', 'none')
                    .text(chart.y1AxisDisplayName)
                    .style('fill', fontColor);

                //adding category name at right hand side
                svg.append("g")
                    .append("text")
                    .attr("y", chart.width / 1.5)
                    .attr("dy", "-9em")
                    .attr("text-anchor", "start")
                    .attr("font-size", "1.1em")
                    //  .style("fill",function(d) { return color(d.key) })
                    .text(function (d) {
                        return d.key
                    });

                svg.selectAll(".barmspc")
                    .data(function (d) {
                        return d.values;
                    })
                    .enter()
                    .append("rect")
                    .attr("class", "barmspc")
                    .attr("x", (d) => {
                        return x1Scale(d.dim1_name);
                    })
                    .attr("width", x1Scale.bandwidth())
                    .attr("y", (d) => {
                        return y1Scale(d.metric1);
                    })
                    .attr("height", (d) => {
                        return chart.height - y1Scale(d.metric1);
                    })
                    .style("fill", (d) => {
                        return metric1ColorScale(d.dim1_name)
                    })
                    .on("mouseover", function(d) {
                        console.log("d",d)
                        tooltip.onMouseOver(d, this, function(d) {
                            return d.dim1_name + colonAnnotation + numberFormat(d.metric1);
                        });
                    })
                    .on('mousemove', function(event) {
                        tooltip.onMouseMove(event);  // Update tooltip position on mouse move
                    })
                    .on("mouseout", function() {
                        tooltip.onMouseLeave();
                    })
                    .on('contextmenu', function(d) {
                        console.log(d)
                        // Prepare clickedData with both axes' info
                        const clickedData = {
                            [chart.insightNavigator.realDataFieldNames.x1RealDataFieldName]: [d.dim1_name], // e.g., "metric1"
                            [chart.insightNavigator.realDataFieldNames.y1RealDataFieldName] : [d.dim2_name]
                        };
                        console.log("clickedData",clickedData);
                        // Generate the menu with current config and filters
                        const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);

                        // Show the context menu
                        contextMenu(menuItems).call(this, clickedData);

                        // Prevent default context menu
                        d3.event.preventDefault();
                    })
                //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

                // svg.call(y1tip);
            });
        } else {
            console.log("inside else condition");
            // Compute the minimum and maximum year and across symbols.
            x1Scale.domain(data.map(function (d) {
                return d.dim1_name;
            }));

            y1Scale.domain([0, d3.max(data.map(function (d) {
                return d.metric1
            }))]);

            var svg = d3.select(divId)
            svg.selectAll("*").remove();
            // Add an SVG element for each country, with the desired dimensions and margin.
            svg = d3.select(divId).selectAll("svg")
                .data(categories)
                .enter()
                .append("svg")
                .attr("width", chart.width + chart.margin.left + chart.margin.right)
                .attr("height", chart.height + chart.margin.top + chart.margin.bottom)
                .call(responsivefy)
                .append("g")
                .attr("transform", "translate(" + chart.margin.left + "," + chart.margin.top + ")")

            var tooltip1 = createTooltip(divId);

            svg.append("g")
                .attr("class", "x axis")
                .attr('class', 'axis-grid')
                .attr("transform", "translate(0," + chart.height + ")")
                .call(x1AxisLabel)
                .style('fill', '#E8E8E8')
                .selectAll('text')
                .style('font-size', axisLabelFontSize)
                .style('text-anchor', 'start')
                .attr('dx', XaxisAttribute)
                .attr('transform', 'rotate(-50)')
                .text(axisTextDim1)

            svg.append("g")
                .style("fill", "white")
                .attr('class', 'y axis-grid')
                .style('fill', 'none')
                .call(y1AxisLabel)
                .selectAll('text')
                .style('font-size', axisLabelFontSize)

            //adding x-y-axis labels
            svg.append("text")
                .attr("transform", "translate(" + (chart.width / 2) + " ," + (chart.height + chart.margin.top + 52) + ")")
                .style("text-anchor", "middle")
                .style('display', 'none')
                .text(chart.x1AxisDisplayName)
                .style('font-size', fontSize)
                .style('fill', fontColor);

            svg.append("text")
                .attr("transform", "rotate(-90)")
                .attr("y", 10)
                .attr("dy", "-4em")
                .style("text-anchor", "end")
                .attr("font-size", fontSize)
                .style('display', 'none')
                .text(chart.y1AxisDisplayName)
                .style('fill', fontColor);

            //adding category name at right hand side
            svg.append("g")
                .append("text")
                .attr("y", chart.width / 1.3)
                .attr("dy", "-9em")
                .attr("text-anchor", "start")
                .attr("font-size", "1.1em")
                .text(function (d) {
                    return d.key
                });


            svg.selectAll(".barmspc")
                .data((d) => {
                    return d.values;
                })
                .enter()
                .append("rect")
                .attr("class", "barmspc")
                .attr("x", (d) => {
                    return x1Scale(d.dim1_name);
                })
                .attr("width", x1Scale.bandwidth())
                .attr("y", (d) => {
                    return y1Scale(d.metric1);
                })
                .attr("height", (d) => {
                    return chart.height - y1Scale(d.metric1);
                })
                .style("fill", (d) => {
                    return metric1ColorScale(d.dim1_name)
                })
                .on("mouseover", function(d) {
                    tooltip1.onMouseOver(d, this, function(d) {
                        return d.dim1_name + colonAnnotation + numberFormat(d.metric1);
                    });
                })
                .on('mousemove', function(event) {
                    tooltip1.onMouseMove(event);  // Update tooltip position on mouse move
                })
                .on("mouseout", function() {
                    tooltip1.onMouseLeave();
                })
                .on('contextmenu', function(d) {
                    console.log(d)
                // Prepare clickedData with both axes' info
                const clickedData = {
                    [chart.insightNavigator.realDataFieldNames.x1RealDataFieldName]: [d.dim1_name], // e.g., "metric1"
                    [chart.insightNavigator.realDataFieldNames.y1RealDataFieldName]:[d.dim2_name]
                };
                console.log("clickedData",clickedData);
                // Generate the menu with current config and filters
                const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);

                // Show the context menu
                contextMenu(menuItems).call(this, clickedData);

                // Prevent default context menu
                d3.event.preventDefault();
            })
            //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

            // svg.call(y1tip);

        }
    // });
}
